import React from "react";
import PropTypes from "prop-types";

const UnreadDot = ({ label }) => (
  <>
    <span className="nav-unread-dot" aria-hidden="true" />
    <span className="sr-only">{label}</span>
  </>
);

UnreadDot.propTypes = {
  label: PropTypes.string,
};

UnreadDot.defaultProps = {
  label: "Unread updates",
};

export default UnreadDot;
